var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._l((_vm.subscriptions),function(subscription,index){return _c('div',{key:index},[_vm._v(" "+_vm._s(subscription.email)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }